import { render } from "./rate-regions-table.vue?vue&type=template&id=6c56275f&scoped=true"
import script from "./rate-regions-table.vue?vue&type=script&lang=js"
export * from "./rate-regions-table.vue?vue&type=script&lang=js"

import "./rate-regions-table.vue?vue&type=style&index=0&id=6c56275f&lang=scss&scoped=true"
import "./rate-regions-table.vue?vue&type=style&index=1&id=6c56275f&lang=scss"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.16_vue@3.5.13_typescript@5.1.6__webpack@5.99.9/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c56275f"]])

export default __exports__